<template>
  <v-dialog
      v-model="showDialog"
      max-width="460px"
      persistent
      scrollable
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Pause {{breakData.id !== '' ? 'bearbeiten' : 'erstellen'}}</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col
              cols="12"
              sm="12"
              md="12"
              class=" pb-0"
          >
            <v-text-field
                label="Pausenname"
                required
                v-model="breakData.name"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mt-1">
          <v-col
              cols="11"
              sm="5"
              class="pt-0 pb-0"
          >
            <v-menu
                ref="menu"
                v-model="tp1"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="breakData.von"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="breakData.von"
                    label="Pausenbeginn"
                    prepend-icon="mdi-clock-time-four-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                  v-if="tp1"
                  v-model="breakData.von"
                  full-width
                  format="24hr"
                  @click:minute="$refs.menu.save(breakData.von)"
              ></v-time-picker>
            </v-menu>
          </v-col>
            <v-spacer               class="mt-0 mb-0"
                                    style="font-size: 40px; text-align: center; padding-top: 10px"><span style="display: inline-block;vertical-align: middle;line-height: normal;">-</span></v-spacer>
          <v-col
              cols="11"
              sm="5"
              class="pt-0 pb-0"

          >
            <v-menu
                ref="menu2"
                v-model="tp2"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="breakData.bis"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="breakData.bis"
                    label="Pausenende"
                    prepend-icon="mdi-clock-time-four-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                  v-if="tp2"
                  v-model="breakData.bis"
                  full-width
                  format="24hr"
                  @click:minute="$refs.menu2.save(breakData.bis)"
              ></v-time-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row class="mt-1">
          <v-col md="12">
            <v-btn-toggle
                v-model="selectedDays"
                class="d-flex"
                multiple
                color="primary"
                style=""
            >
              <v-btn value="mo" style="flex: 1; border-color: #7e7e7e !important;">
                Mo
              </v-btn>
              <v-btn value="di" style="flex: 1; border-color: #7e7e7e !important;">
                Di
              </v-btn>
              <v-btn value="mi" style="flex: 1; border-color: #7e7e7e !important;">
                Mi
              </v-btn >
              <v-btn value="do" style="flex: 1; border-color: #7e7e7e !important;">
                Do
              </v-btn>
              <v-btn value="fr" style="flex: 1; border-color: #7e7e7e !important;">
                Fr
              </v-btn>
              <v-btn value="sa" style="flex: 1; border-color: #7e7e7e !important;">
                Sa
              </v-btn>
              <v-btn value="so" style="flex: 1; border-color: #7e7e7e !important;">
                So
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
                ref="mita"
                label="Für wen gilt die Pause?"
                prepend-icon="mdi-account"
                v-model="mitaValue"
                readonly
                @focusin.stop="showSelectUser"
                @click.stop="showSelectUser"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            @click="showDialog = false; $emit('cancel')"
        >
          Abbrechen
        </v-btn>
        <v-btn
            color="blue darken-1"
            text
            @click="submit"
            :disabled="!canSubmit"
        >
          {{breakData.id !== '' ? 'Speichern' : 'Erstellen'}}
        </v-btn>
      </v-card-actions>
    </v-card>
    <assign-user-dialog :bh-structure="migrStructure" single-select :pre-selected="selectedMita" ref="assignUserDialog" @submit="onMitaSelected"></assign-user-dialog>
  </v-dialog>

</template>

<script>

import AssignUserDialog from "./assign_user_dialog";

export default {
  name: "edit_break_dialog",
  components: {AssignUserDialog},
  props: {
    bhStructure: {
      type: Array,
    },
    currentBreak: {
      type: Object,
    },
  },
  data () {
    return {
      showDialog: false,
      error: false,
      breakData: {
        id: "",
        name: "",
        von: "",
        bis: "",
        mo: false,
        di: false,
        mi: false,
        do: false,
        fr: false,
        sa: false,
        so: false,
        mita: "",
        mita_key: 0,
      },
      mitaValue: "Alle",
      selectedMita: [],
      selectedDays: [],
      tp1: false,
      tp2: false,
    }
  },
  computed: {
    canSubmit() {
      return this.breakData.name.trim() !== '';
    },
    migrStructure() {
      let res = [
          {id: "all", text: "Alle", node_type: "migr", children: []},
      ];
      for (let i = 0; i < this.bhStructure.length; i++) {
        let curr = this.bhStructure[i];
        if (curr.node_type !== 'kostenstelle') {
          res.push(curr);
        } else if (curr.children && curr.children.length > 0) {
          res = res.concat(curr.children);
        }
      }
      return res;
    }
  },
  watch: {

  },
  methods: {
    show() {
      console.log(this.currentBreak);
      this.breakData.id = this.currentBreak.id;
      this.breakData.name = this.currentBreak.name;
      this.breakData.von = this.currentBreak.von.substring(0, 2) + ":" + this.currentBreak.von.substring(2);
      this.breakData.bis = this.currentBreak.bis.substring(0, 2) + ":" + this.currentBreak.bis.substring(2);
      switch (this.currentBreak.mita_key) {
        case 0:
          this.mitaValue = "Alle";
          this.selectedMita = ["all"]
          break;
        case 2:
          let parsed = JSON.parse(sessionStorage.getItem(this.currentBreak.mita));
          if (parsed) {
            this.mitaValue = parsed.full_name;
          }
          this.selectedMita = [this.currentBreak.mita]
          break;
        case 1:
          this.mitaValue = this.currentBreak.mita;
          this.selectedMita = this.findMigr(this.currentBreak.mita)
          break;
        case 3:
          this.mitaValue = "Keinen";
          this.selectedMita = []
          break;
      }
      this.selectedDays = [];
      if (this.currentBreak.mo) {
        this.selectedDays.push("mo");
      }
      if (this.currentBreak.di) {
        this.selectedDays.push("di");
      }
      if (this.currentBreak.mi) {
        this.selectedDays.push("mi");
      }
      if (this.currentBreak.do) {
        this.selectedDays.push("do");
      }
      if (this.currentBreak.fr) {
        this.selectedDays.push("fr");
      }
      if (this.currentBreak.sa) {
        this.selectedDays.push("sa");
      }
      if (this.currentBreak.so) {
        this.selectedDays.push("so");
      }
      this.showDialog = true;
    },
    submit() {
      let res = {
            id: this.breakData.id,
            name: this.breakData.name,
            von: this.breakData.von.replace(":", ""),
            bis: this.breakData.bis.replace(":", ""),
            mo: this.selectedDays.includes("mo"),
            di: this.selectedDays.includes("di"),
            mi: this.selectedDays.includes("mi"),
            do: this.selectedDays.includes("do"),
            fr: this.selectedDays.includes("fr"),
            sa: this.selectedDays.includes("sa"),
            so: this.selectedDays.includes("so"),
            mita: this.breakData.mita,
            mita_key: this.breakData.mita_key,
      };
      this.$emit('submit', res);
      this.showDialog = false;
    },
    showSelectUser(e) {
      if (e.relatedTarget || e.pointerId) {
        this.$refs.assignUserDialog.show();
      }
      this.$refs.mita.blur();
    },
    findMigr(name) {
      for (let i = 0; i < this.migrStructure.length; i++) {
        if (this.migrStructure[i].text === name && this.migrStructure[i].node_type === 'migr') {
          return [this.migrStructure[i].id];
        }
      }
      return [];
    },
    findMigrById(id) {
      for (let i = 0; i < this.migrStructure.length; i++) {
        if (this.migrStructure[i].id === id && this.migrStructure[i].node_type === 'migr') {
          return this.migrStructure[i].text;
        }
      }
      return "";
    },
    onMitaSelected(selection) {
      this.selectedMita = selection;
      if (selection.length === 0) {
        this.mitaValue = "Keinen";
        this.breakData.mita = "";
        this.breakData.mita_key = 3;
      } else if (selection[0] === "all") {
        this.mitaValue = "Alle";
        this.breakData.mita = "";
        this.breakData.mita_key = 0;
      } else if (selection[0].startsWith("MIGR")) {
        this.mitaValue = this.findMigrById(selection[0]);
        this.breakData.mita = this.mitaValue;
        this.breakData.mita_key = 1;
      } else {
        this.mitaValue = selection[0];
        let parsed = JSON.parse(sessionStorage.getItem(selection[0]));
        if (parsed) {
          this.mitaValue = parsed.full_name;
        } else {
          this.mitaValue = selection[0];
        }
        this.breakData.mita = selection[0];
        this.breakData.mita_key = 2;
      }
    }
  }
}
</script>

<style scoped>

</style>
